import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { fetchBookings } from "PFApp/profiles/services/api";
import { Booking } from "PFTypes";

import { CalendarRange } from "../../../types/calendar_range";
import { profileKeys } from "./query_keys";

interface IProps {
  profileId: number;
  dateRange?: CalendarRange;
  options: Omit<UseQueryOptions<Booking[]>, "queryKey" | "queryFn" | "initialData"> & {
    initialData?: () => undefined;
  };
}

export const useProfileBookings = ({ profileId, dateRange, options = {} }: IProps) =>
  useQuery<Booking[]>(
    profileKeys.bookings(profileId, ["list", ...(dateRange ? [dateRange] : [])]),
    async () => (await fetchBookings(profileId, dateRange)).entries,
    {
      retry: false,
      ...options
    }
  );
